<template>
  <div class="so-card" @click.stop="navigate(item.id)">
    <div class="socard-header" :class="occurrenceClass">
      <div class="d-flex align-items-center">
        <div>
          <i class="far fa-star mr-1" />
        </div>
        <div class="flex-grow-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>{{ typeName }}</div>
            <div class="d-flex align-items-center">
              <div v-if="item.linkedMaterialRequestId">
                <button class="badge badgebutton mr-2" v-b-tooltip="'Go to Material Request'" @click.stop="navigate(item.linkedMaterialRequestId)">MatReq</button>
              </div>
              <div v-if="item.aircraftRegistration" class="badge badgebutton active" :id="item.id">
                <i class="far fa-plane text-white" />
                {{ item.aircraftRegistration }}
              </div>
            </div>
          </div>
          <div class="">{{item.name}}</div>
        </div>
        </div>
      </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { ISpecialOccurrenceListDto, ITechnicalOccurrenceDto } from '@/apiclient/apiclient_generated';

  @Component({
    components: {},
  })
  export default class SoCard extends Vue {
    @Prop()
    public item: ISpecialOccurrenceListDto;

    get occurrenceClass(): string {
      if (this.item.cssClass) return this.item.cssClass;

      return 'badge-so';
    }

    get typeName(): string {
      if ((this.item as ITechnicalOccurrenceDto).technicalOccurrenceType)
        return (this.item as ITechnicalOccurrenceDto).technicalOccurrenceType?.name;
      return this.item.type;
    }

    navigate(id: string) {
      this.$router.push({ name: 'special-occurrence', params: { occId: id } });
    }
  }
</script>

<style scoped lang="scss">
  .so-card {
    font-size: 0.8rem;
    margin: 5px;
    outline: none;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);
    background: #4e667d;
    color: white;
    transition: all 0.25s ease-in-out;
    z-index: 1000;
    border-radius: 6px;
    cursor: pointer;

    .socard-header {
      padding: 3px;
      font-weight: bold;
    }

    &:hover {
      background: #eaeaea;
      color: #333;
    }

    .badge-pill {
      font-size: 80%;
    }
  }
</style>
